import { Field, Model } from 'serialize-ts/dist';
import { EnergyEfficiencyLabel } from '~shared/modules/product-card/models/energy-efficiency-label.enum';

@Model()
export class EnergyEfficiencyRange {

  @Field()
  from: EnergyEfficiencyLabel;

  @Field()
  to: EnergyEfficiencyLabel;
}
